import { FileRouteTypes } from '@tanstack/react-router';
import {
  getCoreRowModel,
  getPaginationRowModel,
  OnChangeFn,
  Row,
  SortingState,
  TableOptions,
} from '@tanstack/react-table';
import { OrderSide } from '../../types/generated';

export interface CommonTableProps {
  isFetching: boolean;
  isPending: boolean;
  isError: boolean;
  pagination?: boolean;
  viewAllLink?: FileRouteTypes['fullPaths'];
  // When `paginationKey` changes, the pagination is reset to 0
  paginationKey?: unknown;
  sorting: SortingState;
  setSorting: OnChangeFn<SortingState>;
  fetchNextPage: () => void;
  // Page size props
  pageSize: number;
  pageSizeOptions?: number[];
  setPageSize?: (pageSize: number) => void;
  className?: string;
  style?: React.CSSProperties;
}

// Common table props.
export const getCommonTableParams = ({
  pageSize,
  sorting,
  setSorting,
}: {
  pageSize: number;
  sorting: SortingState;
  setSorting: OnChangeFn<SortingState>;
}) =>
  ({
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: { pagination: { pageSize, pageIndex: 0 } },
    autoResetPageIndex: false,
    enableSorting: true,
    enableMultiSort: false,
    state: { sorting },
    manualSorting: true,
    onSortingChange: setSorting,
    enableSortingRemoval: true,
  }) satisfies Partial<TableOptions<unknown>>;

// Class to set row's left border based on row's order side. The border is
// set on the first cell rather than the row, to make row spacing work.
export const getRowLeftBorderClassName = <TableData extends { side: OrderSide }>(
  row: Row<TableData>
) => {
  const sideClass =
    row.original.side === OrderSide.BUY
      ? '[&>td:first-child]:border-l-borderSuccess'
      : '[&>td:first-child]:border-l-borderError';

  return `[&>td:first-child]:border-l-2 ${sideClass}`;
};
